import React, { memo } from "react";
import Icon from "../Icons/Icon";
import { Handle } from "react-flow-renderer";

export default memo(({ data }) => {
  return (
    <>
      <Handle type="target" position="left" />
      <div className="flow-node">
        {data.label}
        {data.icon && (
          <div className="icon-container">
            <Icon
              icon={data.icon || "ICON_OPENMODAL"}
              style={{
                width: "16px",
                height: "16px",
                cursor: "pointer",
                marginLeft: "5px",
              }}
              onClick={data.onIconClick || (() => {})}
            />
          </div>
        )}
      </div>
      <Handle type="source" position="right" />
    </>
  );
});
